export default __webpack_public_path__ + "static/media/seal.3b66aa94.png";